<script setup>

import { usePage } from '@inertiajs/vue3'
import {trans} from "@/Utils/translation.utils.js";
import {ref, computed, onMounted} from 'vue';

const {nav_bar_data} = usePage().props;
const menuList = ref(nav_bar_data?.header || {});
const menuListArray = computed(() => Object.values(menuList.value || []));
const props = defineProps({
    productCategories: Object
})

const active = ref(0);
const innerActive = ref([])

const getUrl = (url) => {
    return (url && url !== '#') ? url : '';
};

onMounted(() => {
    if (props.productCategories?.data) {
        props.productCategories.data.forEach((_, i) => {
            innerActive.value[i] = 0
        })
    }
});
</script>

<template>
    <div class="home-page-categories mb-5 mt-5">
        <h2 class="text-center mb-4">{{ trans('front.all_marketing_services') }}</h2>
        <div class="tab">
            <div class="tab-menu row justify-content-center">
                <div v-for="(item, index) in productCategories.data" :key="`category_${item.slug}`"
                     class="col-2 col-md-2 col-lg-2 col-xxl-2 " @click="() => active = index">
                    <div :class="['menu__item', { 'is-active': active === index }]">
                        <img :src="item.icon" width="24" loading="lazy" alt="" />
                        <span>{{ item.entity?.name === 'Other Services' ? item.entity.name : item.entity?.name?.replace(/ ?services/i, '')}}</span>
                    </div>
                </div>
            </div>

            <div v-for="(category, categoryIndex) in productCategories.data"
                 :key="`content_category_${category.slug}`"
                 :style="{ display: active === categoryIndex ? 'flex' : 'none' }"
                 class="contents__content">

                <div v-if="menuListArray[categoryIndex]?.submenu" class="submenu-tabs">
                    <div v-for="(subitem, subIndex) in Object.values(menuListArray[categoryIndex]?.submenu || {})"
                         :key="`submenu-item-${subitem.title}`"
                         :class="['menu-sublist__link', { 'is-active': categoryIndex === active && innerActive[categoryIndex] === subIndex }]"
                         @click="innerActive[categoryIndex] = subIndex">
                        <img :src="`/img/icons/icon-${subitem.icon || 'other'}${categoryIndex === active && innerActive[categoryIndex] === subIndex ? '__active' : ''}.svg`" alt="">
                        {{ subitem.title }}
                    </div>
                </div>

                <div v-for="(subitem, subIndex) in Object.values(menuListArray[categoryIndex]?.submenu || {})"
                     :key="`submenu-content-${subitem.title}`"
                     class="submenu-content"
                     :style="{ display: categoryIndex === active && innerActive[categoryIndex] === subIndex ? 'block' : 'none' }">

                    <div class="row align-items-stretch g-0 gx-md-4">
                        <div v-for="supsubitem in Object.values(subitem.submenu || {})"
                             :key="`supsubitem-${supsubitem.title}`"
                             class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                            <a v-if="getUrl(supsubitem.link)" :href="getUrl(supsubitem.link)"
                               class="service-list-item c-card c-card--hovered">
                                <img class="service-list-item__img mb-3" :src="supsubitem.icon" :alt="supsubitem.title" width="72" />
                                <span class="service-list-item__title mb-3">{{ supsubitem.title }}</span>
                                <button class="service-list-item__btn btn btn-outline-primary">{{trans('front.view-pricing')}}</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.service-list-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 1.5rem 1rem;
    font-family: 'Ruda', 'Montserrat', sans-serif;
    height: 100%;

    &:hover {
        text-decoration: none;
    }

    &__title {
        font-size: 1.25rem;
        font-weight: 800;
    }

    &__btn {
        transition: none;
        &:hover {
            border-color: #1e73be;
            background-color: #1e73be;
        }
    }
}
</style>
